import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Avatar, Row, Col, Divider, Popover, Button } from "antd";
import { ReactComponent as LogoHeader } from "../../../assets/img/CONCURSO_PUBLICO.svg";

import { Link } from "react-router-dom";
import { linksRouter } from "../../../config/RouterLink";
import "./HeaderPublic.css";
import {
  Registrarme,
  IniciarSesion,
} from "../../../redux/consultavacantes/sistemasDucks";

/**Ant-design icons */
import { UserOutlined, MenuOutlined } from "@ant-design/icons";

/**Componentes */
import { ModalLogin } from "../Login/ModalLogin";

import { openModalLogin } from "../../../redux/aspirante/aspiranteDucks";

/**
 * Component Header que se muestra en el portal público
 * @return {JSX.Element}  HeaderPublic
 */

export const HeaderPublic = () => {
  const { Header } = Layout;

  const { autenticado } = useSelector((state) => state.usuarioLogin);
  const dispatch = useDispatch();
  //   const { get_iniciarSesion } = useSelector((state) => state.sistemas);

  /**
   *Función para mostrar/ocultar el modal de inicio de sesión
   *
   */
  const openOrCloseModal = () => {
    dispatch(openModalLogin());
  };

  useEffect(() => {
    dispatch(Registrarme());
    dispatch(IniciarSesion());
  }, [dispatch]);

  return (
    <>
      <Header className="mainHeaderPublic">
        <Row type="flex" align="middle">
          <Col
            xxl={2}
            xl={2}
            lg={2}
            md={3}
            sm={3}
            xs={3}
            className="container-logo-header text-center"
          >
            <Link to={linksRouter.home}>
              <LogoHeader className="logoConcurso" />
            </Link>
          </Col>
          <Col
            xxl={10}
            xl={10}
            lg={17}
            md={17}
            sm={17}
            xs={16}
            className="container-titulo-header"
          >
            <Row>
              <Col span={1} className="divider_titulo_header">
                <Divider type="vertical" />
              </Col>
              <Col span={23}>
                <div className="titulo_header">
                  Concursos Públicos de ingreso para ocupar plazas vacantes en
                  cargos
                  <br />y puestos del Servicio Profesional Electoral Nacional
                </div>
              </Col>
            </Row>
          </Col>
          <Col
            xxl={12}
            xl={12}
            lg={4}
            md={4}
            sm={4}
            xs={5}
            className="container-user-header"
          >
            {!autenticado && (
              <Row>
                <Col xxl={24} xl={24} lg={0} md={0} sm={0} xs={0}>
                  <Avatar icon={<UserOutlined />} />
                  <Button
                    type="text"
                    className="btn-user-name"
                    onClick={() => openOrCloseModal()}
                  >
                    Iniciar sesión
                  </Button>
                </Col>
                <Col
                  xxl={0}
                  xl={0}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="container-submenu"
                >
                  <Popover
                    content={
                      <div className="container-header-popover">
                        <Button
                          type="text"
                          className="btn-submenu-login"
                          onClick={() => openOrCloseModal()}
                        >
                          <Avatar icon={<UserOutlined />} />
                          &nbsp; Iniciar sesión
                        </Button>
                      </div>
                    }
                    title=""
                  >
                    <Button className="btn-hamburguer" type="primary">
                      <MenuOutlined />
                    </Button>
                  </Popover>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Header>
      <ModalLogin />
    </>
  );
};
